import React, { forwardRef } from 'react';
import {
  SelectorIcon,
  TrashIcon,
  ArrowsExpandIcon,
} from '@heroicons/react/solid';

interface IProps {
  url: string;
  onDeleteImage: (arg: string) => void;
  [x: string]: any;
}

const Image = forwardRef<HTMLDivElement, IProps>(
  ({ item, index, faded, style, onDeleteImage, listeners, ...props }, ref) => {
    if (!item) return null;

    const inlineStyles = {
      opacity: faded ? '0.2' : '1',
      transformOrigin: '0 0',
      height: index === 0 ? 270 : 130,
      gridRowStart: index === 0 ? 'span 2' : null,
      gridColumnStart: index === 0 ? 'span 2' : null,
      backgroundImage: `url("${item.filePath}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundColor: 'grey',
      ...style,
    };
    // Deleting one or more records;
    const onDelete = (e: React.MouseEvent<HTMLElement>) =>
      onDeleteImage(item.sid);

    return (
      <div
        // image gets drawn within inlineStyles
        ref={ref}
        style={inlineStyles}
        className="z-0 col-span-1 w-full h-full object-cover rounded-lg shadow "
        {...props}
      >
        <div className="group w-full h-full justify-center ">
          <button
            {...listeners} //Drag-n-drop listeners binded to this image wide button
            className="z-10 relative w-full h-full opacity-40 group-hover:opacity-100"
          >
            <ArrowsExpandIcon className="w-full h-full text-gray-800 opacity-0 group-hover:opacity-60" />
          </button>

          <button // Trash can to delete images
            className="z-20 absolute opacity-0 group-hover:opacity-100 border border-1 rounded-lg"
            onClick={onDelete}
          >
            <TrashIcon className="absolute right-1 w-4 h-6 text-gray-800 bg-gray-400 border border-1 rounded-lg opacity-40 hover:opacity-100 hover:bg-gray-100" />
          </button>
        </div>
      </div>
    );
  }
);

export default Image;
